import React from 'react';
import {Modal} from '@forecast-it/design-system';
import {FormattedHTMLMessage, FormattedMessage} from 'react-intl';

type DeletePhaseModalProps = {
	closeModal: () => void;
	callback: () => void;
	hasEstimates?: boolean;
};

const DeletePhaseModal = ({closeModal, callback, hasEstimates}: DeletePhaseModalProps): React.JSX.Element => {
	const deletePhase = () => {
		callback();
		closeModal();
	};
	return (
		<Modal size={Modal.SIZE.SMALL} onCloseModal={closeModal}>
			<Modal.Title>
				<FormattedMessage id={'phase_management.delete_phase_title'} />
			</Modal.Title>
			<Modal.Content>
				<FormattedHTMLMessage id={'phase_management.delete_phase_check'} />
				{hasEstimates ? (
					<FormattedHTMLMessage id={'phase_management.delete_phase_with_baseline'} />
				) : (
					<FormattedHTMLMessage id={'phase_management.delete_phase_without_baseline'} />
				)}
			</Modal.Content>
			<Modal.Footer>
				<Modal.PrimaryFooterButton onPress={deletePhase} dataCy={'modal-btn-confirm-delete'} disabled={false}>
					<FormattedMessage id="phase_management.delete_phase" />
				</Modal.PrimaryFooterButton>
				<Modal.SecondaryFooterButton onPress={closeModal}>
					<FormattedMessage id="common.cancel" />
				</Modal.SecondaryFooterButton>
			</Modal.Footer>
		</Modal>
	);
};

export default DeletePhaseModal;
